import dashboardApi from 'services/api/dashboard'
import config from 'services/config'

import {
  UPDATE_CURRENT_BALANCE,
  UPDATE_GROUP_VIEW_PREFERENCE,
  UPDATE_SUBSIDIARY_ID_FOR_SINGLE_INVOICE
} from './actionTypes'

export const updateCurrentBalance = balance => ({
  type: UPDATE_CURRENT_BALANCE,
  payload: balance
})

export const updateGroupViewPreference = isGroupView => ({
  type: UPDATE_GROUP_VIEW_PREFERENCE,
  payload: isGroupView
})

export const gotInvoices = invoicesData => ({
  type: 'GOT_INVOICES',
  payload: invoicesData
})

export const updateBillableBookings = (invoiceId, hotelId) => {
  return async dispatch => {
    dispatch({
      type: 'UPDATE_BILLABLE_BOOKINGS_STARTED'
    })

    try {
      const response = await dashboardApi.getBillableBookings(invoiceId, hotelId)
      dispatch(gotBillableBookings(response))
    } catch (err) {
      console.warn({ err })
      dispatch({
        type: 'GET_BILLABLE_BOOKINGS_FAILED',
        payload: err
      })
    }
  }
}

export const getBillableBookings = (invoiceId, hotelId) => {
  return async dispatch => {
    dispatch({
      type: 'GET_BILLABLE_BOOKINGS_STARTED'
    })

    try {
      const response = await dashboardApi.getBillableBookings(invoiceId, hotelId)
      dispatch(gotBillableBookings(response))
    } catch (err) {
      console.warn({ err })
      dispatch({
        type: 'GET_BILLABLE_BOOKINGS_FAILED',
        payload: err
      })
    }
  }
}

export const gotBillableBookings = billableBookings => ({
  type: 'GOT_BILLABLE_BOOKINGS',
  payload: { billableBookings, updatedOn: Date.now() }
})

export const selectBillableBookings = (bookingIds, isSelected) => ({
  type: 'SELECT_BILLABLE_BOOKINGS',
  payload: {
    bookingIds,
    isSelected
  }
})

export const deselectAllBillableBookings = () => ({
  type: 'DESELECT_ALL_BILLABLE_BOOKINGS'
})

export const updateBillableBooking = (booking, invoice) => ({
  type: 'UPDATE_BILLABLE_BOOKING',
  payload: {
    booking,
    invoice
  }
})

export const updateInvoice = (invoiceIds, authToken) => {
  return async dispatch => {
    dispatch({
      type: 'UPDATE_STATEMENT_STARTED',
      payload: {
        invoiceIds
      }
    })

    try {
      let invoiceData

      if (authToken) {
        const res = await fetch(`${config.apiUrl}/billing/invoices`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Cache-Control': 'no-cache',
            'sp-auth2': authToken
          },
          body: JSON.stringify({ invoiceIds })
        })

        const { result } = await res.json()

        invoiceData = result
      } else {
        invoiceData = await dashboardApi.getInvoice(invoiceIds)
      }

      dispatch({
        type: 'GET_STATEMENT_SUCCESS',
        payload: invoiceData.reduce((prev, curr) => {
          return {
            ...prev,
            [curr.invoiceDetails.subsidiaryInvoiceId]: curr
          }
        }, {})
      })
    } catch (err) {
      console.warn({ err })
      dispatch({
        type: 'GET_STATEMENT_FAILED',
        payload: err
      })
    }
  }
}

export const getInvoice = (invoiceIds, authToken) => {
  return async dispatch => {
    dispatch({
      type: 'GET_STATEMENT_STARTED',
      payload: {
        invoiceIds
      }
    })

    try {
      let invoiceData

      if (authToken) {
        const res = await fetch(`${config.apiUrl}/billing/invoices`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Cache-Control': 'no-cache',
            'sp-auth2': authToken
          },
          body: JSON.stringify({ invoiceIds })
        })

        const { result } = await res.json()

        invoiceData = result
      } else {
        invoiceData = await dashboardApi.getInvoice(invoiceIds)
      }

      dispatch({
        type: 'GET_STATEMENT_SUCCESS',
        payload: invoiceData.reduce((prev, curr) => {
          return {
            ...prev,
            [curr.invoiceDetails.subsidiaryInvoiceId]: curr
          }
        }, {})
      })
    } catch (err) {
      console.warn({ err })
      dispatch({
        type: 'GET_STATEMENT_FAILED',
        payload: err
      })
    }
  }
}

export const updateSubsidiaryIdForSingleInvoice = subsidiaryId => ({
  type: UPDATE_SUBSIDIARY_ID_FOR_SINGLE_INVOICE,
  payload: subsidiaryId
})
